import React from 'react';
import fr from 'facet-rest';
import { pickFunction } from 'Helpers/Affordances';
import NotActive from './NotActive';

const NotActivePicker = ({ resource }) => {
  return pickFunction(resource, {
    [fr.relationships.view.name]: () => {
      if (resource.attr('isPassingVerification') === 'true') {
        return null;
      }

      return (
        <NotActive
          resource={resource}
        />
      );
    },
    [fr.relationships.default.name]: () => {
      return null;
    },
  });
};

export default NotActivePicker;
